import { useCallback, useEffect, useRef } from 'react';

type FrameCallback = () => void;

/**
 *	Runs a callback on every animation frame.
 *
 *	@param callback () => void Called on each frame
 */
export function useRequestAnimationFrame(callback: FrameCallback): void {
	const ref = useRef<FrameCallback>(callback);
	const raf = useRef<number>(0);

	ref.current = callback;

	const tick = useCallback((): void => {
		ref.current();
		raf.current = requestAnimationFrame(tick);
	}, []);

	useEffect(() => {
		raf.current = requestAnimationFrame(tick);
		return () => cancelAnimationFrame(raf.current);
	}, [tick]);
}
